import { APIConfiguration } from '@savgroup-front-common/configuration';
import { COMMON_QUERY_PARAMS } from '@savgroup-front-common/constants';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  OwnerSummaryDto,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.owner}owners/id/${COMMON_QUERY_PARAMS.OWNER_ID}`;

export interface GetOwnerByIdArgs {
  ownerId: string;
}

export const getOwnerByIdRequest = (
  payload: GetOwnerByIdArgs,
): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.OWNER_ID, payload.ownerId),
  config: { method: SUPPORTED_METHODS.GET },
});

export async function getOwnerById(
  payload: GetOwnerByIdArgs,
): Promise<BackResponse<OwnerSummaryDto> | BackResponseFailure> {
  try {
    return await executeQuery<BackResponse<OwnerSummaryDto>>(
      getOwnerByIdRequest(payload),
    );
  } catch (e) {
    return prepareResponseFailure(e);
  }
}
